import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CounterpartyPage from './pages/CounterpartyPage/CounterpartyPage';
import InformationOfRegistrationPage from './pages/InformationOfRegistrationPage/InformationOfRegistrationPage';
import SelectionOfSuppliersPage from './pages/SelectionOfSuppliersPage/SelectionOfSuppliersPage';
import PurchasingHistoryPage from './pages/PurchasingHistoryPage/PurchasingHistoryPage';
import NmcContentPage from './pages/NmcContentPage/NmcContentPage';
import Logout from './pages/LogoutPage';
import Sidebar from './blocks/Sidebar';

import style from './layout/PageLayout/pageLayout.module.scss';
import TruContentPage from './pages/TruContentPage/TruContentPage';
import SelectSectionPage from './pages/SelectSectionPage/SelectSectionPage';
import PopUp from './blocks/PopUp';
import RnkimContentPage from './pages/RnkimContentPage/RnkimContentPage';
import ZakupRosneftContentPage from './pages/ZakupRosneftContentPage/ZakupRosneftContentPage';
import ReportRegionContentPage from './pages/ReportRegionContentPage/ReportRegionContentPage';
import SearchPriceOffersPage from './pages/SearchPriceOffersPage/SearchPriceOffersPage';
import isGuidValid from '../assets/utils/guids/helpers/isGuidValid';
import { GUIDKEYS } from '../assets/utils/guids/types';
import RouterBlock from './blocks/RouterBlock/RouterBlock';
import KimSummaryPage from './pages/KimGroupPage/KimSummaryPage';
import KimCustomersDynamicsPage from './pages/KimGroupPage/KimCustomersDynamicsPage';
import KimSuppliersDynamicsPage from './pages/KimGroupPage/KimSuppliersDynamicsPage';
import KimCustomersSuppliersPage from './pages/KimGroupPage/KimCustomersSuppliersPage';
import NmckFuelCalculationPage from './pages/NmckGroupPage/NmckFuelCalculationPage';
import NmckMedicalDevicesCalculationPage from './pages/NmckGroupPage/NmckMedicalDevicesCalculationPage';
import NmckSecurityServicesCalculationPage from './pages/NmckGroupPage/NmckSecurityServicesCalculationPage';
import NmckMedicinesCalculationPage from './pages/NmckGroupPage/NmckMedicinesCalculationPage';

const App: React.FC = () => {
  const [isPopUp, setIsPopUp] = useState(false);

  // @ts-ignore
  const user = useSelector((state) => state.user.userData);
  const handleOnClosePopUp = () => {
    setIsPopUp(false);
  };

  useEffect(() => {
    const ua = navigator.userAgent;
    if (ua.includes('SputnikBrowser')) {
      setIsPopUp(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PopUp
        isOpen={isPopUp}
        onPopUp={handleOnClosePopUp}
        text="Браузер Спутник не поддерживается, для корректной работы портала необходимо использовать другой браузер"
      />
      <div className={style.wrapper}>
        <BrowserRouter>
          <RouterBlock />
          <Sidebar />
          <Switch>
            <Route path="/" component={CounterpartyPage} exact />
            <Route path="/nonAuth" component={SelectSectionPage} exact />
            <Route path="/selection-of-suppliers-page" component={SelectionOfSuppliersPage} exact />
            <Route path="/information-of-registration-page" component={InformationOfRegistrationPage} exact />
            <Route path="/purchasing-history-page" component={PurchasingHistoryPage} exact />
            <Route path="/logout-page" component={Logout} exact />
            <Route path="/nmc" component={NmcContentPage} />
            <Route path="/tru" component={TruContentPage} />
            <Route path="/nmck/nmck-gsm" component={NmckFuelCalculationPage} />
            <Route path="/nmck/nmck-med" component={NmckMedicalDevicesCalculationPage} />
            <Route path="/nmck/nmck-guard" component={NmckSecurityServicesCalculationPage} />
            <Route path="/nmck/nmck-drugs" component={NmckMedicinesCalculationPage} />
            <Route
              path="/rnkim"
              render={() => {
                const isValid = isGuidValid(user, GUIDKEYS.RNKIM);
                if (!isValid) return <Redirect to="/" />;
                return <RnkimContentPage />;
              }}
            />
            <Route
              path="/zakupki_rosneft"
              render={() => {
                const isValid = isGuidValid(user, GUIDKEYS.ZAKUPKI_ROSNEFT);
                if (!isValid) return <Redirect to="/" />;
                return <ZakupRosneftContentPage />;
              }}
            />
            <Route
              path="/rn-region-report"
              render={() => {
                const isValid = isGuidValid(user, GUIDKEYS.REPORT_REGION);
                if (!isValid) return <Redirect to="/" />;
                return <ReportRegionContentPage />;
              }}
            />
            <Route path="/offers-request" component={SearchPriceOffersPage} />
            <Route
              path="/kim-summary"
              render={() => {
                const isValid = isGuidValid(user, GUIDKEYS.KIM);
                if (!isValid) return <Redirect to="/" />;
                return <KimSummaryPage />;
              }}
            />
            <Route
              path="/kim-customers-dynamics"
              render={() => {
                const isValid = isGuidValid(user, GUIDKEYS.KIM);
                if (!isValid) return <Redirect to="/" />;
                return <KimCustomersDynamicsPage />;
              }}
            />
            <Route
              path="/kim-suppliers-dynamics"
              render={() => {
                const isValid = isGuidValid(user, GUIDKEYS.KIM);
                if (!isValid) return <Redirect to="/" />;
                return <KimSuppliersDynamicsPage />;
              }}
            />
            <Route
              path="/kim-customers-suppliers"
              render={() => {
                const isValid = isGuidValid(user, GUIDKEYS.KIM);
                if (!isValid) return <Redirect to="/" />;
                return <KimCustomersSuppliersPage />;
              }}
            />
            <Route
              path="/:slug"
              render={({ match }) => {
                const { slug } = match.params;
                const arr = slug?.replace('http://localhost:5050/', '').split(',');
                if (arr[0] !== 'undefined') localStorage.setItem('innRouter', JSON.stringify(`${arr[0]}`));
                return <CounterpartyPage slug={arr[1] || arr[0]} />;
              }}
            />
          </Switch>
        </BrowserRouter>
      </div>
    </>
  );
};

export default App;
